import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -12","key":"svg-0"}]]

const IconCropPortrait = createReactComponent('outline', 'crop-portrait', 'CropPortrait', __iconNode);

export default IconCropPortrait;